import type { OrderByDirection } from '@domain/enum/OrderByDirection';
import type { PuzzleSortField } from '@domain/usecases/puzzles/PuzzleSortField';

export const SORT_OPTIONS = [
	{
		value: 'name|asc',
		label: 'screens.creator.sortDropdown.nameAtoZ',
	},
	{
		value: 'name|desc',
		label: 'screens.creator.sortDropdown.nameZtoA',
	},
	{
		value: 'publishedAt|asc',
		label: 'screens.creator.sortDropdown.oldest',
	},
	{
		value: 'publishedAt|desc',
		label: 'screens.creator.sortDropdown.newest',
	},
	{
		value: 'plays|asc',
		label: 'screens.creator.sortDropdown.playsLeast',
	},
	{
		value: 'plays|desc',
		label: 'screens.creator.sortDropdown.playsMost',
	},
	{
		value: 'likes|asc',
		label: 'screens.creator.sortDropdown.likesLeast',
	},
	{
		value: 'likes|desc',
		label: 'screens.creator.sortDropdown.likesMost',
	},
] as const satisfies Array<{ value: `${PuzzleSortField}|${OrderByDirection}`; label: string }>;
